import React from "react";

import { PaginatedTableBody } from "../PaginatedTableBody";
import { usePaginationTableContext } from "../PaginatedTable/context";
import { EntrataUsersTableBodyRow } from "./EntrataUsersTableBodyRow";

export const EntrataUsersTableBody = () => {
  const { rows } = usePaginationTableContext();

  return (
    <PaginatedTableBody>
      {rows.map((row, idx) => (
        <EntrataUsersTableBodyRow key={row.id} {...row} />
      ))}
    </PaginatedTableBody>
  );
};
